import { AccountProvider } from '@ecom/storefront-auth-db';

export const getProviderDisplayName = (provider: AccountProvider): string => {
  switch (provider) {
    case AccountProvider.FACEBOOK:
      return 'Facebook';
    case AccountProvider.GOOGLE:
      return 'Google';
    default:
      return provider;
  }
};
